import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { App } from '@df/core/app';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { GSAPModule } from '@df/ui/display/gsap/gsap.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { LocalVimeoPlayerComponent } from '../../../../../ui/display/media/vimeo-player.component';
import config from './feature-banner-v2.config';
import { IPageComponentFeatureBannerV2Data } from './feature-banner-v2.interface';

@Component({
    selector: 'page-component-feature-banner-v2',
    templateUrl: './feature-banner-v2.html',
    styleUrl: './feature-banner-v2.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        GSAPModule,
        HrefComponent,
        DfImageDirective,
        ICmsClientModule,
        LocalVimeoPlayerComponent,
        ShellComponent,
        SizeClassDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentFeatureBannerV2Component>(config)
export class PageComponentFeatureBannerV2Component extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentFeatureBannerV2Data;

    protected app = inject(App);

    shareColumnsTop(item: IPageComponentFeatureBannerV2Data): string {
        switch (item.images_gallery_option) {
            case 'two_top_one_bottom':
            case 'two_top_two_bottom':
                return ' w-6 w-12-s';
        }
        return '';
    }

    show2ndImg(item: IPageComponentFeatureBannerV2Data): boolean {
        switch (item.images_gallery_option) {
            case 'two_top_one_bottom':
            case 'two_top_two_bottom':
                return true;
            case 'one_top_two_bottom':
            case 'one_top_one_bottom':
                return false;
        }
    }

    shareColumnsBottom(item: IPageComponentFeatureBannerV2Data): string {
        switch (item.images_gallery_option) {
            case 'one_top_two_bottom':
            case 'two_top_two_bottom':
                return ' w-6 w-12-s';
        }
        return '';
    }

    show4rdImg(item: IPageComponentFeatureBannerV2Data): boolean {
        switch (item.images_gallery_option) {
            case 'two_top_one_bottom':
            case 'one_top_one_bottom':
                return false;
            case 'two_top_two_bottom':
            case 'one_top_two_bottom':
                return true;
        }
    }

    canAnimate() {
        return !this.client.isCms && this.component?.animation && this.app.isPlatformBrowser;
    }
}
